import C from "@babel/runtime/helpers/esm/objectSpread2";
import x from "@babel/runtime/helpers/esm/classCallCheck";
import I from "@babel/runtime/helpers/esm/createClass";
import u from "@babel/runtime/helpers/esm/assertThisInitialized";
import P from "@babel/runtime/helpers/esm/inherits";
import E from "@babel/runtime/helpers/esm/createSuper";
import e from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as k } from "@semcore/utils/lib/core/index";
import D, { sstyled as w, assignProps as $, Component as N } from "@semcore/core";
import g from "react";
import { Box as T } from "@semcore/flex-box";
import V from "@semcore/utils/lib/enhances/contextEnhance";
var M = (
  /*__reshadow_css_start__*/
  (k.insert(
    /*__inner_css_start__*/
    ".___SAnimation_1pbqm_gg_{animation-fill-mode:both;animation-timing-function:var(--timingFunction_1pbqm);animation-duration:var(--durationFinalize_1pbqm);animation-delay:var(--delayFinalize_1pbqm);animation-name:var(--keyframesFinalize_1pbqm)}.___SAnimation_1pbqm_gg_.__transition-based_1pbqm_gg_{transition-timing-function:var(--timingFunction_1pbqm);transition-duration:var(--durationFinalize_1pbqm);transition-delay:var(--delayFinalize_1pbqm)}.___SAnimation_1pbqm_gg_.__visible_1pbqm_gg_{animation-duration:var(--durationInitialize_1pbqm);animation-delay:var(--delayInitialize_1pbqm);animation-name:var(--keyframesInitialize_1pbqm)}.___SAnimation_1pbqm_gg_.__visible_1pbqm_gg_.__transition-based_1pbqm_gg_{transition-timing-function:var(--timingFunction_1pbqm);transition-duration:var(--durationInitialize_1pbqm);transition-delay:var(--delayInitialize_1pbqm)}@media (prefers-reduced-motion){.___SAnimation_1pbqm_gg_.__transition-based_1pbqm_gg_,.___SAnimation_1pbqm_gg_.__visible_1pbqm_gg_.__transition-based_1pbqm_gg_{transition-timing-function:none;transition-duration:none;transition-delay:none}.___SAnimation_1pbqm_gg_,.___SAnimation_1pbqm_gg_.__visible_1pbqm_gg_{animation-timing-function:step-end;animation-iteration-count:1}}",
    "1pbqm_gg_"
  ), {
    __SAnimation: "___SAnimation_1pbqm_gg_",
    "--timingFunction": "--timingFunction_1pbqm",
    "--durationFinalize": "--durationFinalize_1pbqm",
    "--delayFinalize": "--delayFinalize_1pbqm",
    "--keyframesFinalize": "--keyframesFinalize_1pbqm",
    "_transition-based": "__transition-based_1pbqm_gg_",
    _visible: "__visible_1pbqm_gg_",
    "--durationInitialize": "--durationInitialize_1pbqm",
    "--delayInitialize": "--delayInitialize_1pbqm",
    "--keyframesInitialize": "--keyframesInitialize_1pbqm"
  })
);
function b(s) {
  return Array.isArray(s) ? s : [s, s];
}
var R = function() {
  var m = {
    onAnimationStartSubscribers: [],
    onAnimationStart: function(n) {
      return m.onAnimationStartSubscribers.push(n), function() {
        return m.onAnimationStartSubscribers.filter(function(t) {
          return t !== n;
        });
      };
    },
    onAnimationEndSubscribers: [],
    onAnimationEnd: function(n) {
      return m.onAnimationEndSubscribers.push(n), function() {
        return m.onAnimationEndSubscribers.filter(function(t) {
          return t !== n;
        });
      };
    }
  };
  return m;
}, S = /* @__PURE__ */ g.createContext(null), d = /* @__PURE__ */ function(s) {
  P(_, s);
  var m = E(_);
  function _() {
    var n;
    x(this, _);
    for (var t = arguments.length, a = new Array(t), r = 0; r < t; r++)
      a[r] = arguments[r];
    return n = m.call.apply(m, [this].concat(a)), e(u(n), "state", {
      animationRunning: !1,
      render: n.props.visible || n.props.preserveNode,
      wasInvisible: !n.props.visible
    }), e(u(n), "animationSupported", !1), e(u(n), "animationContext", R()), e(u(n), "onAnimationStart", function() {
      n.animationSupported = !0;
      var i = n.asProps, l = i.animationsDisabled, o = i.parentAnimationContext, c = l ? [0, 0] : b(n.asProps.duration), v = o ?? n.animationContext;
      v.onAnimationStartSubscribers.forEach(function(p) {
        return p(c[0]);
      });
    }), e(u(n), "onAnimationEnd", function(i) {
      n.animationSupported = !0, n.handleAnimationEnd();
    }), e(u(n), "handleAnimationEnd", function() {
      !n.asProps.visible && !n.props.preserveNode && n.setState({
        render: !1
      });
      var i = n.asProps.parentAnimationContext, l = i ?? n.animationContext;
      l.onAnimationEndSubscribers.forEach(function(o) {
        return o();
      });
    }), e(u(n), "animationEventFallback", function() {
      if (n.state.render && !n.animationSupported) {
        var i = n.asProps.animationsDisabled ? [0, 0] : b(n.asProps.delay), l = n.asProps.visible ? i[0] : i[1], o = n.asProps.animationsDisabled ? 0 : n.asProps.duration + 100;
        setTimeout(function() {
          n.animationSupported || n.handleAnimationEnd();
        }, o + l);
      }
    }), n;
  }
  return I(_, [{
    key: "componentDidMount",
    value: function() {
      this.animationEventFallback();
    }
  }, {
    key: "componentDidUpdate",
    value: function(t, a) {
      (t.visible !== this.props.visible || a.render !== this.state.render) && this.animationEventFallback();
    }
  }, {
    key: "render",
    value: function() {
      var t = this.asProps, a, r = T, i = this.asProps, l = i.styles, o = i.keyframes, c = i.initialAnimation, v = i.timingFunction, p = i.animationsDisabled, f = i.parentAnimationContext, h = f ?? this.animationContext, A = p ? [0, 0] : b(this.asProps.duration), y = p ? [0, 0] : b(this.asProps.delay), q = this.state, z = q.render, F = q.wasInvisible;
      return z ? /* @__PURE__ */ g.createElement(S.Provider, {
        value: h
      }, (a = w(l), /* @__PURE__ */ g.createElement(r, a.cn("SAnimation", C({}, $({
        onAnimationStart: this.onAnimationStart,
        onAnimationEnd: this.onAnimationEnd,
        durationInitialize: "".concat(A[0], "ms"),
        durationFinalize: "".concat(A[1], "ms"),
        delayInitialize: "".concat(y[0], "ms"),
        delayFinalize: "".concat(y[1], "ms"),
        timingFunction: v,
        keyframesInitialize: F || c ? o[0] : "totally-no-animations",
        keyframesFinalize: o[1]
      }, t)))))) : null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(t, a) {
      var r = a.wasInvisible || !t.visible;
      return t.visible || t.preserveNode || a.wasInvisible !== r ? {
        render: !0,
        wasInvisible: r
      } : a;
    }
  }]), _;
}(N);
e(d, "displayName", "Animation");
e(d, "style", M);
e(d, "defaultProps", {
  visible: !1,
  duration: 0,
  delay: 0,
  keyframes: [],
  initialAnimation: !1,
  timingFunction: "ease-out",
  animationsDisabled: !1
});
e(d, "enhance", [V(S, "parentAnimationContext")]);
const Y = D(d);
export {
  S as animationContext,
  Y as default
};
